import decimalField from "../../common/decimal-field.vue";
import dateField from "../../common/date-field";
import notesSlider from "../../common/notes-slider";
import { hasValue } from "../../../utils/functions.js";
export default {
  name: "prospects",
  components: {
    decimalField,
    dateField,
    notesSlider
  },
  data() {
    return {
      PaymentMethods: [],
      allPaymentMethods: [],
      allTaxes: [],
      includedPaymentCodes: [],
      paymentMethodToAdd: null,
      businessMonthlyFee: 0,
      withdrawalFee: 0,
      marketplaceMonthlyFee: 0,
      ProspectNotes: [],
      ProspectProposals: [],
      Prospects: [],
      countFilter: 1,
      currentPage: 1,
      filter: {
        Name: null,
        Identity: null,
        IsExpired: false,
        IdUserPartner: null
      },
      hasErrorOnProposals: null,
      infoProspect: this.DefaultInfoProspect(),
      infoProspectProposal: {
        Code: null,
        Title: null,
        Text: null,
        PaymentMethod: null,
        ProposalData: null,
        PaymentMethods: null,
        EmissionDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        DueDate: this.$options.filters.date(this.$options.filters.addDay(new Date(), 7), "YYYY-MM-DD"),
        UserPartner: null,
        Prospect: null,
        IsOnlyGenerate: false,
        AdditionalPlan: "Marketplace"
      },
      isCreating: false,
      isExpired: false,
      isSeeing: false,
      isSeeingProspectProposal: false,
      rowKeys: {},
      validityDays: 7,
      // Ordem fixa das seções (preview E texto enviado ao backend precisam usar a mesma):
      // Plano, Boleto, Pix Recebimento, Cartão, Antifraude, Antecipação, Pix Pagamento, SMS.
      sectionOrderMap: { 1: 2, 6: 3, 2: 4, 16: 5, 15: 6, 13: 7, 14: 8 },
      planOrder: 1,
      keyNotes: 0,
      labelIdentity: "CNPJ",
      labelName: "Empresa",
      loadingAddNote: false,
      loadingGenerate: false,
      loadingModal: false,
      loadingPList: false,
      loadingProposal: false,
      loadingReport: false,
      loadingCheckProspect: false,
      users: [],
      mCurrentStep: 0,
      mSteps: ["prospect", "notes", "proposals"],
      modalProposalTitle: "Proposta",
      modalTitle: "Novo prospect",
      note: {
        Description: null
      },
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      promiseAddNote: [],
      promises: [],
      taxesMaxMin: [],
      taxes: [],
      validatedFormValidation: false,
      idSolicitationDate: null,
      solicitationDate: null,
      validatedFormSolicitationDate: false,
      minDateSolicitation: this.$options.filters.addDay(new Date(), 6)
    };
  },
  computed: {
    IsAdministrator() {
      return this.$profileCode() === "1";
    },
    ValidityDays() {
      // Ao gerar, usa o valor selecionado direto (evita erro de ±1 dia por fuso horário
      // ao recalcular a partir de EmissionDate/DueDate). Ao visualizar uma proposta já
      // gerada, não existe seletor — recalcula a partir das datas salvas.
      if (!this.isSeeingProspectProposal) return this.validityDays;
      const emission = new Date(this.infoProspectProposal.EmissionDate);
      const due = new Date(this.infoProspectProposal.DueDate);
      const diff = Math.round((due - emission) / (1000 * 60 * 60 * 24));
      return diff > 0 ? diff : 0;
    },
  },
  watch: {
    "infoProspectProposal.AdditionalPlan"() {
      if (this.configurationTaxes) this.BuildTaxesForPlan();
      this.GetPaymentMethod();
    },
    validityDays(nv) {
      // Usa "new Date()" (data local de hoje) em vez de reinterpretar a string EmissionDate,
      // que o JS trata como meia-noite UTC e pode voltar um dia em fusos negativos (ex.: Brasil).
      this.infoProspectProposal.DueDate = this.$options.filters.date(
        this.$options.filters.addDay(new Date(), nv),
        "YYYY-MM-DD"
      );
    },
    "pagination.PageNumber"() {
      this.GetProspects();
    },
    "pagination.RowsPerPage"() {
      this.GetProspects();
    }
  },
  beforeMount() {
    this.$requestGetCommissionCompetence();
    this.$store
      .dispatch("GetCommissionCompetence")
      .then(resp => {
        resp.forEach(elm => {
          let max = null;
          let min = 100;
          elm.CommissionCompetence.forEach(tax => {
            if (tax.Tax > max) max = tax.Tax;
            if (tax.Tax < min) min = tax.Tax;
          });
          this.taxesMaxMin.push({
            PaymentCode: elm.PaymentMethod.Code,
            MaxValue: max,
            MinValue: min
          });
        });
      })
      .catch(error => {
        this.$makeToast("Não foi possível buscar a lista de comissões", "danger", "Lista de Comissões", error);
      });
  },
  mounted() {
    if (this.IsAdministrator) this.ListSalesMan();
    this.GetProspects();
  },
  methods: {
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    OpenModalSolicitationDate(prospectId) {
      this.validatedFormSolicitationDate = false;
      this.idSolicitationDate = prospectId;
      this.solicitationDate = null;
      this.$bvModal.show("mSolicitationDate");
    },
    Filter() {
      this.$bvModal.hide("mFilter");
      this.GetProspects();
    },
    HasNotes() {
      return this.ProspectNotes != null && this.ProspectNotes.length > 0 && this.ProspectNotes[0].Description != "";
    },
    Placeholder(key, valueToValidate, caseTrue, caseFalse) {
      if (key == valueToValidate) return caseTrue;
      else return caseFalse;
    },
    ResetFilter() {
      this.filter = {
        Name: null,
        Identity: null,
        IsExpired: false,
        IdUserPartner: null
      };
      this.GetProspects();
    },
    ListSalesMan() {
      let data = {
        "Object.UserProfilePartner.Code": 2,
        PageNumber: 0,
        RowsPerPage: 0
      };
      this.$store
        .dispatch("ListUser", { params: data })
        .then(response => {
          this.users = response.Objects;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de usuários", error);
        });
    },
    GetReport(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportProspect", { params: data })
        .then(response => {
          if (response.UrlReport != null && response.UrlReport != undefined && response.UrlReport != "") {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(
            "Falha ao gerar relatório, tente novamente mais tarde.",
            "danger",
            "Geração de relatório",
            error
          );
        })
        .finally(() => {
          setTimeout(() => {
            $("#meu-querido-dropdown > .dropdown-menu").removeClass("show");
            this.loadingReport = false;
          }, 250);
        });
    },
    GetSendClass(isSendProposal) {
      return isSendProposal ? "fas fa-check fa-green" : "fas fa-minus";
    },
    GetAvailableClass(isAvailable) {
      return isAvailable ? "fas fa-user-check fa-green" : "fas fa-user-times fa-red";
    },
    AddNote() {
      let self = this;

      this.note.Prospect = {};
      this.note.Prospect.Id = this.infoProspect.Id;
      this.loadingAddNote = true;
      // Add
      this.$store
        .dispatch("AddProspectNote", this.note)
        .then(res => {
          self.$makeToast("Comentário adicionado com sucesso.", "success", "Comentário");
          if (this.ProspectNotes.length > 1) {
            self.ProspectNotes.push(res);
          } else {
            this.GetProspectNotes(this.infoProspect.Id);
          }

          self.note.Description = null;
        })
        .catch(error => {
          self.$makeToast("Não foi possível adicionar o comentário.", "danger", "Comentário", error);
        })
        .finally(() => {
          Promise.all(this.promiseAddNote).then(() => {
            this.loadingAddNote = false;

            if (this.$refs.carousel != undefined) {
              this.$refs.carousel.GoToSlide(this.ProspectNotes.length - 1);
            }
          });
        });
    },
    ConfirmRemovalPymtMethod(pymtMethodCode) {
      const idxPymt = this.taxes.findIndex(elm => {
        return elm.PaymentMethod.Code == pymtMethodCode;
      });
      let payment = this.taxes[idxPymt];

      this.$makeMsgBox(
        "Só será possivel adicionar novamente a forma de pagamento gerando uma nova proposta. " +
          "A descrição da forma de pagamento também será removida da proposta.",
        `Tem certeza que deseja remover o método de pagamento ${payment.PaymentMethod.Name}?`,
        this.RemovePaymentMethod,
        pymtMethodCode
      );
    },
    GetParamsData(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Name": this.filter.Name,
        "Object.Identity": this.filter.Identity,
        "Object.IsExpired": this.filter.IsExpired,
        "Object.UserPartner.Id": this.filter.IdUserPartner
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.RowsPerPage;
        delete data.PageNumber;
      }
      return data;
    },
    GetProspects() {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.IsExpired)) this.countFilter++;
      if (hasValue(this.filter.IdUserPartner)) this.countFilter++;
      this.loadingPList = true;
      let data = this.GetParamsData();
      this.$store
        .dispatch("GetProspects", { params: data })
        .then(response => {
          this.Prospects = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
          this.isExpired = this.filter.IsExpired;
        })
        .catch(error => {
          this.$makeToast("Não foi possível buscar os prospects", "danger", "Listagem de Prospect", error);
        })
        .finally(() => {
          this.loadingPList = false;
        });
    },
    GetProspect(e, id, seeing, isOnlyGet = false) {
      e.preventDefault();
      this.loadingModal = true;
      this.isCreating = false;
      if (typeof seeing != "undefined") {
        this.isSeeing = true;
        this.modalTitle = "Detalhes do prospect";
      } else {
        this.isSeeing = false;
        this.modalTitle = "Editar prospect";
      }
      if (isOnlyGet == false) this.OpenMProspect();

      // GET PROSPECT PROPOSALS
      let promProposals = new Promise(resolve => {
        this.$store
          .dispatch("ListProspectProposal", { idProspect: id })
          .then(response => {
            this.ProspectProposals = response;
            this.hasErrorOnProposals = false;
          })
          .catch(error => {
            this.hasErrorOnProposals = true;
            this.$makeToast(
              "Um erro genérico ocorreu, tente reabrir o prospect.",
              "danger",
              "Erro ao carregar propostas",
              error
            );
          })
          .finally(() => {
            resolve();
          });
      });
      this.promises.push(promProposals);

      // GET PROSPECT OBJECT
      let promProspect = new Promise(resolve => {
        this.$store
          .dispatch("GetProspect", { id: id })
          .then(response => {
            this.ProspectNotes = response.ProspectNotes;
            delete response.ProspectNotes;

            this.infoProspect = response;
          })
          .catch(error => {
            this.$makeToast(
              "Não foi possível buscar as informações do prospect",
              "danger",
              "Informações de Prospect",
              error
            );
          })
          .finally(() => {
            resolve();
          });
      });
      this.promises.push(promProspect);

      Promise.all(this.promises).then(() => {
        this.loadingModal = false;
      });
    },
    GetProspectNotes(id) {
      let promProspectNotes = new Promise(resolve => {
        this.$store
          .dispatch("GetProspectNotes", { IdProspect: id })
          .then(resp => {
            this.ProspectNotes = resp;
            this.keyNotes += 1;
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            resolve();
          });
      });
      this.promiseAddNote.push(promProspectNotes);
    },
    GetPaymentMethod() {
      // Mesma ordem do preview (this.sectionOrderMap/this.planOrder) — o texto enviado ao
      // backend precisa refletir exatamente o que o comercial viu antes de gerar.
      const entries = [];
      let textCreditCard = "";
      let creditCardEntry = null;

      this.taxes.forEach(element => {
        if (element.PaymentMethod.Code == "2") {
          textCreditCard = textCreditCard + "\n" + this.GetTextCreditCard(element);
          if (element.EndInstallment == 12) {
            creditCardEntry = {
              order: this.sectionOrderMap[2],
              text:
                `<b>${element.PaymentMethod.Name}</b>` +
                `${textCreditCard}` +
                "\n" +
                `${element.PaymentMethod.Description}` +
                "\n"
            };
          }
        } else {
          entries.push({ order: this.sectionOrderMap[element.PaymentMethod.Code] || 99, text: this.GetText(element) });
        }
      });

      if (creditCardEntry) entries.push(creditCardEntry);

      // MOCK: Plano Business/Marketplace ainda não têm flag vindo do backend — texto fixo até a API existir.
      if (this.infoProspectProposal.AdditionalPlan == "Business") {
        entries.push({ order: this.planOrder, text: this.GetBusinessPlanText() });
      } else if (this.infoProspectProposal.AdditionalPlan == "Marketplace") {
        entries.push({ order: this.planOrder, text: this.GetMarketplaceText() });
      }

      entries.sort((a, b) => a.order - b.order);
      this.infoProspectProposal.PaymentMethod = entries.map(entry => entry.text).join("\n");
      this.BuildProposalData();
    },
    BuildProposalData() {
      // PROPOSTA DE CONTRATO (não confirmada com o backend ainda): nomes batendo com os
      // placeholders do template proposta-comercial-template.html. Campo adicional, enviado
      // junto com o "PaymentMethod" de texto (que continua sendo o que o backend usa hoje).
      const amountFor = code => {
        const tax = this.taxes.find(t => t.PaymentMethod.Code == code);
        return tax ? tax.Amount : null;
      };
      const amountForInstallment = initialInstallment => {
        const tax = this.taxes.find(t => t.PaymentMethod.Code == 2 && t.InitialInstallment == initialInstallment);
        return tax ? tax.Amount : null;
      };

      this.infoProspectProposal.ProposalData = {
        NomeCliente: this.infoProspectProposal.Prospect ? this.infoProspectProposal.Prospect.Name : null,
        CpfCnpjCliente: this.infoProspectProposal.Prospect ? this.infoProspectProposal.Prospect.Identity : null,
        DataEmissao: this.$options.filters.date(this.infoProspectProposal.EmissionDate, "DD/MM/YYYY"),
        DataValidade: this.validityDays,
        NomeContato: this.infoProspectProposal.UserPartner ? this.infoProspectProposal.UserPartner.Name : null,
        EmailContato: this.infoProspectProposal.UserPartner ? this.infoProspectProposal.UserPartner.Email : null,
        TelefoneContato: this.infoProspectProposal.UserPartner ? this.infoProspectProposal.UserPartner.Phone : null,
        Modalidade: this.infoProspectProposal.AdditionalPlan,
        MensalidadeMarketplace: this.marketplaceMonthlyFee || null,
        MensalidadeBusiness: this.businessMonthlyFee || null,
        TaxaSaque: this.withdrawalFee || null,
        DiasRepasseBoleto: 2,
        ValorBoleto: amountFor(1),
        TarifaPixRecebimento: amountFor(6),
        TaxaCartao1x: amountForInstallment(1),
        TaxaCartao2a6x: amountForInstallment(2),
        TaxaCartao7a12x: amountForInstallment(7),
        ValorAntifraude: amountFor(16),
        TaxaAntecipacao: amountFor(15),
        ValorPixPagamento: amountFor(13)
      };
    },
    BuildPaymentMethodsPayload() {
      // Lista estruturada e tipada (mesma forma de ConfigurationTax) enviada pro backend montar
      // o HTML da proposta — inclui os métodos normais (this.taxes) mais as taxas do plano
      // escolhido (mensalidade + taxa de saque), que não aparecem na tabela normal.
      const planTaxes = [];
      const configTaxes = this.configurationTaxes || [];

      if (this.infoProspectProposal.AdditionalPlan == "Business") {
        const fee = configTaxes.find(t => t.PaymentMethod.Code == 28 && t.MerchantType.Code == 2);
        if (fee) planTaxes.push(fee);
      } else if (this.infoProspectProposal.AdditionalPlan == "Marketplace") {
        const fee = configTaxes.find(t => t.PaymentMethod.Code == 27 && t.MerchantType.Code == 3);
        if (fee) planTaxes.push(fee);
      }

      const withdrawal = configTaxes.find(t => t.PaymentMethod.Code == 26 && t.MerchantType.Code == 2);
      if (withdrawal) planTaxes.push(withdrawal);

      return [...this.taxes, ...planTaxes];
    },
    GetMarketplaceText() {
      return (
        "<b>Marketplace</b>\n" +
        `- Mensalidade: ${this.ProposalCurrency(this.marketplaceMonthlyFee)}\n` +
        (this.withdrawalFee
          ? `- Taxa de saque: ${this.ProposalCurrency(this.withdrawalFee)} (repasse diário ou semanal)\n`
          : "") +
        "- Crie Subcontas e Splits de Pagamento ilimitados\n" +
        "- Liberdade de markup, aplicação de sobretaxas para as subcontas e monetização\n" +
        "- Subcontas sem tarifa de manutenção\n" +
        "- Atendimento dedicado de Integração, Suporte e Gestor de Contas\n" +
        "- Split dos pagamentos gratuito entre inúmeras contas\n" +
        "- Não há multa rescisória ou tempo mínimo de contrato\n"
      );
    },
    GetBusinessPlanText() {
      return (
        "<b>Business</b>\n" +
        `- Mensalidade: ${this.ProposalCurrency(this.businessMonthlyFee)}\n` +
        (this.withdrawalFee
          ? `- Taxa de saque: ${this.ProposalCurrency(this.withdrawalFee)} (repasse diário ou semanal)\n`
          : "") +
        "- Atendimento dedicado de Integração, Suporte e Gestor de Contas\n" +
        "- Não há multa rescisória ou tempo mínimo de contrato\n"
      );
    },
    GetProspectProposalUrl() {
      this.loadingGenerate = true;
      this.infoProspectProposal.PaymentMethods = this.BuildPaymentMethodsPayload();
      this.$store
        .dispatch("GetProspectProposalUrl", this.infoProspectProposal)
        .then(response => {
          if (response.UrlProposal != null && response.UrlProposal != undefined && response.UrlProposal != "") {
            this.GetProspects();
            this.$bvModal.hide("mFormProspectProposal");
            window.open(response.UrlProposal, "_self");
          }
        })
        .catch(error => {
          this.$makeToast("Falha ao gerar proposta, tente novamente.", "danger", "Erro ao gerar a proposta", error);
        })
        .finally(() => (this.loadingGenerate = false));
    },
    GetExpirationDaysLegend(days) {
      if (days == null) return "";
      if (days > 1) {
        return days + " dias";
      } else if (days > 0) {
        return days + " dia";
      } else {
        return "Hoje";
      }
    },
    GetSpanClass(daysToExpiration) {
      let variation = "badge badge-danger";
      if (daysToExpiration > 20) {
        variation = "badge badge-success";
      } else if (daysToExpiration > 10 && daysToExpiration <= 20) {
        variation = "badge badge-warning";
      }
      return variation;
    },
    GetText(element) {
      return (
        `<b>${element.PaymentMethod.Name}</b>` +
        "\n" +
        `${this.GetTextAmount(element, false)}` +
        "\n" +
        `${element.PaymentMethod.Description}` +
        `${element.PaymentMethod.Description !== "" ? "\n" : ""}`
      );
    },
    GetTextAmount(element, creditCard) {
      if (creditCard) {
        return ` (percentual por transação): ${this.$options.filters.percentage(element.Amount)}`;
      }
      if (element.PaymentMethod.Code == 6) {
        return `- Tarifa de ${this.ProposalCurrency(element.Amount)} por transação recebida`;
      }
      return element.TaxType.Code == 1
        ? `- Percentual por transação: ${this.$options.filters.percentage(element.Amount)}`
        : `- Valor por transação: ${this.ProposalCurrency(element.Amount)}`;
    },
    GetTextCreditCard(element) {
      let text = "";
      if (element.InitialInstallment == element.EndInstallment) {
        text = `- Em ${element.InitialInstallment} ${element.InitialInstallment == 1 ? "vez" : "vezes"}`;
      } else {
        text = `- De ${element.InitialInstallment} até ${element.EndInstallment} vezes`;
      }
      return text + " " + this.GetTextAmount(element, true);
    },
    ProposalCurrency(value) {
      // O filtro "currency" global do app usa símbolo à direita (ex.: "0,99 R$");
      // a proposta comercial precisa do símbolo à esquerda (ex.: "R$ 0,99"), como no PDF real.
      const [intPart, decPart] = Number(value).toFixed(2).split(".");
      const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return `R$ ${withThousands},${decPart}`;
    },
    GoToStep(event, stepToGo) {
      if (event !== null) event.preventDefault();

      if (stepToGo <= this.mSteps.length && stepToGo >= 0) {
        this.mCurrentStep = stepToGo;
      }
    },
    OpenProspectProposalDisabled(e, id) {
      e.preventDefault();
      this.loadingProposal = true;
      this.isSeeingProspectProposal = true;
      this.$bvModal.show("mFormProspectProposal");
      this.$store
        .dispatch("GetProspectProposal", { id: id })
        .then(response => {
          this.infoProspectProposal = response;
          this.infoProspectProposal.IsOnlyGenerate = true;
          this.modalProposalTitle = `Proposta para ${this.infoProspectProposal.Prospect.Name}`;
        })
        .catch(error => {
          this.loadingProposal = false;
          this.$makeToast("Falha ao carregar proposta, tente novamente", "danger", "Erro ao carregar proposta", error);
        })
        .finally(() => (this.loadingProposal = false));
    },
    OpenProspectProposal(e, id) {
      e.preventDefault();
      this.loadingProposal = true;
      this.isSeeingProspectProposal = false;
      this.paymentMethodToAdd = null;
      this.rowKeys = {};
      this.validityDays = 7;
      this.$bvModal.show("mFormProspectProposal");
      let userPartner = this.$getUserPartner();
      delete userPartner.Image;
      this.$store
        .dispatch("GetProspect", { id: id })
        .then(responseProspect => {
          this.infoProspectProposal = {
            Code: responseProspect.CodeProspectProposal,
            Title: `Proposta PRO${responseProspect.CodeProspectProposal} - v1`,
            Text: null,
            PaymentMethod: null,
            ProposalData: null,
        PaymentMethods: null,
            EmissionDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
            DueDate: this.$options.filters.date(this.$options.filters.addDay(new Date(), 7), "YYYY-MM-DD"),
            UserPartner: userPartner,
            Prospect: responseProspect,
            IsOnlyGenerate: false,
            AdditionalPlan: "Marketplace"
          };
          this.modalProposalTitle = `Gerar proposta para ${this.infoProspectProposal.Prospect.Name}`;
          this.$store
            .dispatch("ListConfigurationTax", { params: { PageNumber: 0, RowsPerPage: 0 } })
            .then(response => {
              this.configurationTaxes = response.Objects;

              // Mensalidade de Business/Marketplace não são métodos de pagamento da proposta:
              // ficam sob o "Plano" (radio), com o valor vindo da própria API.
              const businessFee = this.configurationTaxes.find(
                t => t.PaymentMethod.Code == 28 && t.MerchantType.Code == 2
              );
              const marketplaceFee = this.configurationTaxes.find(
                t => t.PaymentMethod.Code == 27 && t.MerchantType.Code == 3
              );
              const withdrawalFee = this.configurationTaxes.find(
                t => t.PaymentMethod.Code == 26 && t.MerchantType.Code == 2
              );
              this.businessMonthlyFee = businessFee ? businessFee.Amount : 0;
              this.marketplaceMonthlyFee = marketplaceFee ? marketplaceFee.Amount : 0;
              this.withdrawalFee = withdrawalFee ? withdrawalFee.Amount : 0;

              this.BuildTaxesForPlan();
              this.GetPaymentMethod();
            })
            .catch(error => {
              this.$makeToast(
                "Falha ao carregar a lista de taxas, tente novamente.",
                "danger",
                "Erro carregar a lista de taxas.",
                error
              );
            })
            .finally(() => (this.loadingProposal = false));
        })
        .catch(error => {
          this.loadingProposal = false;
          this.$makeToast(
            "Ocorreu um erro ao buscar o prospect, tente novamente",
            "danger",
            "Erro ao carregar Prospect",
            error
          );
        });
    },
    RemovePaymentMethod(pymtCode) {
      this.includedPaymentCodes = this.includedPaymentCodes.filter(code => code != pymtCode);
      this.RebuildIncludedTaxes();
      this.GetPaymentMethod();
    },
    AddPaymentMethod() {
      if (this.paymentMethodToAdd == null) return;

      this.includedPaymentCodes.push(this.paymentMethodToAdd);
      this.paymentMethodToAdd = null;
      this.RebuildIncludedTaxes();
      this.GetPaymentMethod();
    },
    RebuildIncludedTaxes() {
      this.taxes = this.allTaxes.filter(tax => this.includedPaymentCodes.includes(tax.PaymentMethod.Code));
      this.PaymentMethods = this.allPaymentMethods.filter(pymt => this.includedPaymentCodes.includes(pymt.Code));
    },
    BuildTaxesForPlan() {
      // As taxas exibidas seguem o MerchantType do plano escolhido (Business=2, Marketplace=3),
      // não o MerchantType cadastrado no prospect — cada plano tem tabela de taxas própria.
      const merchantTypeCode = this.infoProspectProposal.AdditionalPlan == "Business" ? 2 : 3;

      this.allTaxes = this.configurationTaxes.filter(function(confTax) {
        return (
          confTax.MerchantType.Code == merchantTypeCode &&
          confTax.PaymentMethod.Code != 28 &&
          confTax.PaymentMethod.Code != 27 &&
          confTax.PaymentMethod.Code != 26
        );
      });

      this.allPaymentMethods = [];
      let map = new Map();
      this.allTaxes.forEach(tax => {
        if (!map.has(tax.PaymentMethod.Code)) {
          this.allPaymentMethods.push({ Code: tax.PaymentMethod.Code, Name: tax.PaymentMethod.Name });
          map.set(tax.PaymentMethod.Code, true);
        }
      });

      // Tudo vem incluído na proposta por padrão; remover é reversível via "Adicionar método de pagamento".
      this.includedPaymentCodes = this.allPaymentMethods.map(pymt => pymt.Code);
      this.paymentMethodToAdd = null;
      this.rowKeys = {};

      this.RebuildIncludedTaxes();
    },
    RowId(tax) {
      return `${tax.PaymentMethod.Code}-${tax.InitialInstallment}`;
    },
    RowKey(tax, idxTax) {
      return `tax-${idxTax}-${this.rowKeys[this.RowId(tax)] || 0}`;
    },
    BumpRowKey(tax) {
      const id = this.RowId(tax);
      this.$set(this.rowKeys, id, (this.rowKeys[id] || 0) + 1);
    },
    RemoveProspectValidate(i) {
      this.$makeMsgBox("Você tem certeza que deseja remover este prospect?", "Confirmar", this.RemoveProspect, i);
    },
    RemoveProspect(i) {
      let deleted = this.Prospects[i];
      let self = this;

      this.$store
        .dispatch("DeleteProspect", { id: deleted.Id })
        .then(() => {
          self.$makeToast(`${deleted.Name} foi removido da sua lista de prospects.`, "success", "Prospect excluído.");
          self.FeedbackModal();
        })
        .catch(error => {
          self.$makeToast("Não foi possível remover o prospect", "danger", "Remoção de Prospect", error);
        });
    },
    OnFocusOutRow(tax) {
      let taxMaxMin = this.taxesMaxMin
        .filter(elm => {
          return elm.PaymentCode == tax.PaymentMethod.Code;
        })
        .shift();
      const curAmount = tax.Amount;

      // Check if the current amount is on the acceptable range.
      if (curAmount > taxMaxMin.MaxValue || curAmount < taxMaxMin.MinValue) {
        // Change amount temporarily with the max or min value.
        let tempValue = null;
        if (curAmount > taxMaxMin.MaxValue) tempValue = taxMaxMin.MaxValue;
        if (curAmount < taxMaxMin.MinValue) tempValue = taxMaxMin.MinValue;
        tax.Amount = tempValue;
        this.BumpRowKey(tax);
        this.GetPaymentMethod();

        // Format values as Currency or Percentage
        let min,
          max,
          cur = null;
        if (tax.TaxType.Code == 1) {
          min = this.$options.filters.percentage(taxMaxMin.MinValue);
          max = this.$options.filters.percentage(taxMaxMin.MaxValue);
          cur = this.$options.filters.percentage(curAmount);
        } else {
          min = this.$options.filters.currency(taxMaxMin.MinValue);
          max = this.$options.filters.currency(taxMaxMin.MaxValue);
          cur = this.$options.filters.currency(curAmount);
        }
        cur = cur ? `(${cur})` : "";

        this.$makeMsgBox(
          `Você inseriu um valor ${cur} fora do intervalo para o método de pagamento ` +
            `'${tax.PaymentMethod.Name}'. O valor deve estar dentro do intervalo ` +
            `${min} - ${max}. Por favor contate o nosso suporte para maiores informações.`,
          `Confirmar valor fora do intervalo?`,
          this.ProcessValueOutInterval,
          tax,
          curAmount
        );
      }
    },
    OnValueChangeRow(tax, newValue) {
      if (tax.PaymentMethod.Code == 2 && tax.InitialInstallment == 1) {
        let lastValue = newValue;
        this.taxes.forEach(elm => {
          if (elm.PaymentMethod.Code == 2 && elm.InitialInstallment != 1) {
            elm.Amount = lastValue + 0.5;
            lastValue += 0.5;
            this.BumpRowKey(elm);
          }
        });
      }
      this.GetPaymentMethod();
    },
    OpenMProspect(checkProspect = false) {
      // Reset modal info first
      this.infoProspect = this.DefaultInfoProspect();
      if (checkProspect === true) {
        this.mCurrentStep = 0;
        this.modalTitle = "Verificar disponibilidade de prospect";
      } else this.mCurrentStep = 1;
      this.validatedFormValidation = false;
      this.ProspectProposals = [];
      this.hasErrorOnProposals = null;
      this.note.Description = null;
      this.loadingAddNote = false;
      this.promises = [];

      this.$bvModal.show("mFormProspect");
    },
    OpenMNewProspect() {
      this.isCreating = true;
      this.modalTitle = "Novo prospect";

      this.OpenMProspect(true);
    },
    ProcessValueOutInterval(tax, amount) {
      tax.Amount = amount;
      this.BumpRowKey(tax);
      this.GetPaymentMethod();
    },
    DefaultInfoProspect() {
      return {
        ContactName: null,
        Email: null,
        ExpirationDate: null,
        Identity: null,
        Name: null,
        Phone: null,
        MerchantType: {
          Code: 2
        },
        Merchant: null,
        UserPartner: {
          Id: 0
        }
      };
    },
    ShouldBeRendered(tax, deleteBtn = false) {
      if (tax.PaymentMethod.Code != 2) return true;
      if (tax.PaymentMethod.Code == 2) {
        if (tax.InitialInstallment == 2 && deleteBtn) return true;
        if (tax.InitialInstallment == 1 && deleteBtn) return false;
        if (tax.InitialInstallment == 1) return true;
      }
      return false;
    },
    AddProspect() {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then(valid => {
        if (valid) {
          this.CallAddProspectAPI();
        }
      });
    },
    CallAddProspectAPI() {
      let self = this;
      this.loadingModal = true;
      if (self.isCreating) {
        // Add
        this.$store
          .dispatch("AddProspect", this.infoProspect)
          .then(() => {
            self.$makeToast("Sucesso ao adicionar o prospect", "success", "Prospect adicionado!");
            self.FeedbackModal();
          })
          .catch(error => {
            self.$makeToast(
              "Não foi possível adicionar o prospect, tente novamente.",
              "danger",
              "Falha ao adicionar Prospect",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      } else {
        // Update
        this.$store
          .dispatch("UpdateProspect", this.infoProspect)
          .then(() => {
            self.$makeToast("Alteração de Prospect", "success", "Sucesso ao alterar o prospect");
            self.FeedbackModal();
          })
          .catch(error => {
            self.$makeToast(
              "Não foi possível alterar o prospect, tente novamente.",
              "danger",
              "Falha ao alterar Prospect",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    FeedbackModal() {
      this.GetProspects();
      this.$bvModal.hide("mFormProspect");
    },
    ProcessAddProspectHistory(e) {
      this.validatedFormSolicitationDate = true;
      e.preventDefault();
      this.$refs.formValidationSolicitationDate.validate().then(valid => {
        if (valid) {
          this.$makeMsgBox(
            "Você tem certeza que deseja renovar o cadastro deste prospect? O setor de atendimento da Safe2Pay fará uma análise da sua solicitação.",
            "Confirmar",
            this.AddProspectHistory
          );
        }
      });
    },
    AddProspectHistory() {
      let userPartner = this.$getUserPartner();
      let prospectHistory = {
        Prospect: {
          Id: this.idSolicitationDate
        },
        UserPartner: {
          Id: userPartner.Id
        },
        SolicitationDate: this.solicitationDate
      };
      this.$store
        .dispatch("AddProspectHistory", prospectHistory)
        .then(() => {
          this.$makeToast("Sucesso ao solicitar a renovação", "success", "Prospect");
          this.$bvModal.hide("mSolicitationDate");
        })
        .catch(error => {
          this.$makeToast("Não foi possível solicitar a renovação", "danger", "Prospect", error);
        });
    },
    ProcessCreateMerchant(e, prospectId) {
      e.preventDefault();
      this.$makeMsgBox(
        "Você tem certeza que deseja definir este prospect como cliente?",
        "Confirmar",
        this.CreateMerchantPreview,
        prospectId
      );
    },
    CreateMerchantPreview(prospectId) {
      let prospectMerchant;
      this.$store.dispatch("GetProspect", { id: prospectId }).then(response => {
        prospectMerchant = response;
        this.$router.push({
          name: "partners-merchant-preview",
          params: { prospect: prospectMerchant }
        });
      });
    },
    CheckProspect() {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then(valid => {
        if (valid) {
          this.loadingCheckProspect = true;
          this.$store
            .dispatch("CheckProspect", this.infoProspect)
            .then(() => {
              this.$makeToast("Prospect verificado com sucesso.", "success", "Verificação de prospect");
              this.modalTitle = "Novo prospect";
              this.GoToStep(null, 1);
            })
            .catch(error => {
              this.$makeToast("O prospect já existe no sistema.", "danger", "Verificação de prospect", error);
            })
            .finally(() => {
              this.loadingCheckProspect = false;
              this.validatedFormValidation = false;
            });
        }
      });
    },
    OpenMUserPartner(e, id) {
      this.GetProspect(e, id, true, true);
      this.$bvModal.show("mUserPartner");
    },
    ConfirmUpdateProspectUserPartner() {
      this.$makeMsgBox(
        "Você tem certeza que deseja vincular o vendedor(a) a este prospect?",
        "Confirmar",
        this.UpdateProspectUserPartner
      );
    },
    UpdateProspectUserPartner() {
      this.infoProspect.UserPartner.Id = this.infoProspect.UserPartner.Id;
      this.$store
        .dispatch("UpdateProspectUserPartner", this.infoProspect)
        .then(() => {
          this.$makeToast("O vendedor foi vinculado com sucesso!", "success", "Vinculação de vendedor");
          this.$bvModal.hide("mUserPartner");
          this.GetProspects();
        })
        .catch(error => {
          this.$makeToast("Não foi possível vincular o Vendedor.", "danger", "Vinculação de vendedor", error);
        })
        .finally(() => {
          this.loadingModal = false;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/prospects/prospects.js